import { Outlet } from 'react-router-dom';
import { useState } from 'react';

/**
 * HomeLayout — 랜딩(공공데이터/AI/통합메인) 라우트의 공통 레이아웃.
 *
 * 네비게이션은 각 랜딩 페이지가 직접 렌더한다(메인=TopNav light, 그 외=TopNav overlay).
 * 레이아웃은 풀페이지 템플릿 호환을 위해 isNavHide 컨텍스트만 전달한다.
 */
export default function HomeLayout() {
  const [isNavHide, setIsNavHide] = useState(true);
  return <Outlet context={{ isNavHide, setIsNavHide }} />;
}
